import { useMemo } from 'react';
import { useLingui } from '@lingui/react/macro';
import { useSettings } from '@wu/widget-core';
import type { FiltersStyle } from '../../../../types';
import { useAvailableFilters } from '../../../utils/use-available-filters';
import { TagsControlWrapper } from './tags-control-wrapper';

type TagsProps = {
  setting: string;
  type: FiltersStyle;
};

export const Tags = (props: TagsProps) => {
  const {
    filterItems: { tags }
  } = useAvailableFilters();
  const { t } = useLingui();
  const { locations } = useSettings();

  const sortedTags = useMemo(() => {
    const usedTagsIds = locations.flatMap((loc) => loc.tags);

    const counts = usedTagsIds.reduce<Record<string, number>>((acc, id) => {
      acc[id] = (acc[id] || 0) + 1;
      return acc;
    }, {});

    return [...tags].sort((a, b) => {
      const diff = (counts[b.id] || 0) - (counts[a.id] || 0);
      return diff || a.name?.localeCompare(b.name);
    });
  }, [tags, locations]);

  return (
    <TagsControlWrapper
      {...props}
      label={t`Tags`}
      options={sortedTags.map(({ id, name, icon }) => ({
        value: id,
        label: name,
        iconSrc: icon?.url
      }))}
    />
  );
};
